module.exports = __webpack_public_path__ + "static/media/neutral_happy.d7bb02a8.svg";